//import Conclusion from './Conclusion';
import './BlogTemplate.scss';

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate,useParams } from 'react-router-dom';

// import Footer from '../../Components/shared/Footer/Footer';
import FooterConsulting from '../../Components/shared/Footer/FooterConsulting';
import NavbarConsulting from '../../Components/shared/Navbar/NavbarConsulting';
// import NavbarHome from '../../Components/shared/Navbar/NavbarHome';
import { blogsDataConsulting } from './InterfacesBlogs';
//from './../../Assets/homePage/ImgBox1Container7.png';
//import Header from './Header';
//import Introduction from './Introduction';
//import Section from './Section';

const BlogTemplateConsulting = () => {

    const { id } = useParams();
    const [selectedBlog,setSelectedBlog]=useState();
    //const {device}=useWindowSize();
    const { i18n } = useTranslation();

    useEffect(() => {
        if(id){
            //console.log('blogsDataConsulting.find(({ id }) => id === parseInt(id)).blog',blogsDataConsulting.find(({ id }) => id == parseInt(id)).blog);
            setSelectedBlog(blogsDataConsulting.find(({ id:blogId }) => blogId == parseInt(id))?.blog);
        }
    },[id]);

    const navigate = useNavigate();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    //console.log(('id',id,'selectedBlog',selectedBlog));
    //const [selectedBlog, setSelectedBlog] = useState(null);
    //const handleBlogClick = (blogId) => {
    //    console.log('blogsDataConsulting.find(({ id }) => id === blogId).blog',blogsDataConsulting.find(({ id }) => id === blogId).blog);
    //    setSelectedBlog(blogsDataConsulting.find(({ id }) => id === blogId).blog);
    //};
    return (
        <div style={{display:'flex',flexDirection:'column',width:'100%'}}>
            <NavbarConsulting />
            {selectedBlog &&
                <div className='blogFrame0'  >

                    <div
                        className='frame42HomePage'
                        style={{width:'85%',maxWidth:'1301px',minWidth: '700px',gap:'60px'}}
                    >
                        {selectedBlog?.image &&
                            <div

                                className='frame43HomePage'
                                style={{height:'auto',width:'auto'}}
                            >
                                <img
                                    src={selectedBlog?.image}
                                    width={'600px'}
                                    height={'396px'}
                                    style={{borderRadius:'20px'}}
                                />
                            </div>
                        }
                        <div
                            className='frame44HomePage'
                            style={{width:'96px'}}
                            //ref={refFocus}
                            //tabIndex={13}
                        >

                            {/*<h3 className='frame26HomePage'>Sur HTH, permettez aux missions de vous trouver!</h3>*/}
                            <p
                                className='blogFrame6'
                            >{selectedBlog.date}</p>
                            <h4 className='homeExpertf13'>{i18n.t(selectedBlog?.title)}</h4>
                            <p
                                className='blogFrame6'
                                style={{color:'#475063'}}
                            >{selectedBlog.minuteRead}{'min en lecture'}</p>
                            <p
                                style={{
                                    fontFamily: 'Lato',
                                    fontSize: '12px',
                                    fontWeight: '400',
                                    lineHeight: '16px',
                                    letterSpacing: '0.004em',
                                    textAlign: 'left',
                                    color:'#827F7F',
                                }}
                            > {i18n.t('Par')} <span style={{color:'#475063'}}> {i18n.t('l\'équipe HTH')}</span></p>
                        </div>
                    </div>

                    <div className='blogFrame2'>
                        {selectedBlog?.sections.map((section, index) => (
                            <div key={index}>
                                <h6 className='blogFrame3'>{i18n.t(section.title)}</h6>
                                <p className='blogFrame4'>
                                    {i18n.t(section.content)}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            }
            <FooterConsulting
                styleProps={{background: '#005E23',
                }}
            />
        </div>
    );
};

export default BlogTemplateConsulting;
